import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-arrow-metro-0",
  "use": "app-icon-arrow-metro-0-usage",
  "viewBox": "0 0 150 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 150 15\" id=\"app-icon-arrow-metro-0\"><g fill=\"#E6E6E6\" fill-rule=\"evenodd\"><path d=\"M9 4.5h130v5.647H9zM149.993 7.464l-10.927 7.529V-.066z\" /><path d=\"M.066 7.464l10.927 7.529V-.066z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol